import { Component, forwardRef, Renderer2, ViewChild, Input, OnInit, OnChanges, EventEmitter, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CompanyService } from '../../../employee/service/company/company.service';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AutocompleteCompanyComponent),
  multi: true,
};

@Component({
  selector: 'app-autocomplete-company',
  templateUrl: './autocomplete-company.component.html',
  styleUrls: ['./autocomplete-company.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class AutocompleteCompanyComponent implements ControlValueAccessor, OnInit, OnChanges {
  @Input() companyId: number;
  @Input() companyPosition: string;
  @Output() onMyChange = new EventEmitter();
  @Input() disabled: boolean;

  @ViewChild('input') textarea;

  public companiesOptions: any[];

  public onChange;
  public onTouched;
  public totalRecords: number;
  public page: number;
  public per_page: number;
  public sort: string;
  public query: string;
  public filters: { key: string, value: string }[];

  public sel: any;

  constructor(
    private renderer: Renderer2,
    public companyService: CompanyService
  ) {
    this.page = 1;
    this.per_page = 10;
  }

  public ngOnInit() {

  }

  ngOnChanges() {
    this.query = undefined;
    this.filters = [];
    this.filters.push({ key: 'activated-lk', value: '1' });

    if (this.companyPosition)
      this.filters.push({ key: 'company_position_id', value: this.companyPosition });

    if (this.companyId) {
      this.filters.push({ key: 'id-in', value: String(this.companyId) });
      this.getCompanies(this.query, this.filters);
    }
  }

  writeValue(value: any) {
    const div = this.textarea.nativeElement;
    // this.renderer.setProperty(div, 'textContent', value);
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  public change($event) {
    if (this.sel.id || this.sel == "") {
      this.onMyChange.emit(this.sel);
      this.onChange(this.sel);
      this.onTouched(this.sel);
    }
  }

  public loadCompaniesLazy(event) {
    var str = event.query;
    var res = str.replace(/\s/g, "%");
    this.getCompanies(res);
  }

  getCompanies(query?: string, filters?: any[]) {
    this.companyService.getCompany(this.page, this.per_page, this.sort, query, this.filters).toPromise().then(
      response => {
        this.companiesOptions = response.json().data;
        if (this.companyId) {
          this.companyId = undefined;
          this.sel = this.companiesOptions[0];
          this.change(null);
          this.filters = [];
          this.filters.push({ key: 'activated-lk', value: '1' });
          if (this.companyPosition) {
            this.filters.push({ key: 'company_position_id', value: this.companyPosition });
          }
        }
      },
      error => {
        this.companiesOptions = [];
        this.companiesOptions.push({ id: '', name: 'Error' });
      }
    );
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/custom-autocomplete/components/autocomplete-company/autocomplete-company.component.ts